import { render, staticRenderFns } from "./FloatingLabelInput.vue?vue&type=template&id=01ed6f0d&scoped=true"
import script from "./FloatingLabelInput.vue?vue&type=script&lang=js"
export * from "./FloatingLabelInput.vue?vue&type=script&lang=js"
import style0 from "./FloatingLabelInput.vue?vue&type=style&index=0&id=01ed6f0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ed6f0d",
  null
  
)

export default component.exports